// extracted by mini-css-extract-plugin
module.exports = {"banner":"_2A3uBk","content":"_3G0_4x","closeButton":"_2krnbn","title":"_1x2kuy","subTitle":"_1E3m60","arrow":"_2w96G1"};